export default function (object, container, mode = 'cover') {
  const objectRatio = object.width / object.height;
  const containerRatio = container.width / container.height;

  if (mode === 'fill') {
    return {
      width: container.width,
      height: container.height,
    };
  }

  if (mode === 'cover') {
    if (objectRatio > containerRatio) {
      return {
        width: Math.round(container.height * objectRatio),
        height: container.height,
      };
    }

    return {
      width: container.width,
      height: Math.round(container.width / objectRatio),
    };
  }

  if (mode === 'contain') {
    if (containerRatio > objectRatio) {
      return {
        width: Math.round(container.height * objectRatio),
        height: container.height,
      };
    }

    return {
      width: container.width,
      height: Math.round(container.width / objectRatio),
    };
  }

  return {
    width: object.width,
    height: object.height,
  };
}
